import script from "./SectionDocumentHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionDocumentHtml.vue?vue&type=script&setup=true&lang=js"

import "./SectionDocumentHtml.vue?vue&type=style&index=0&id=568c4a68&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568c4a68"]])

export default __exports__